import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2225_weekly_off_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Add Weekly Off",
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "holiday_weekly_off",
                TableName: "holiday_weekly_off",
                DisplayName: "Weekly Off",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                childComponents: [
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "parent_id",
                        BindValue: "parent_id",
                        Json_Attribute: "parent_id",
                        style: { display: "none" },
                    } as any,
                    {
                        componentType: ComponentType.SELECT_DROPDOWN,
                        name: "day_of_week",
                        label: "Day",
                        placeholder: "Select Day",
                        required: true,
                        BindValue: "day_of_week",
                        Json_Attribute: "day_of_week",
                        options: [
                            { label: "Monday", value: "Monday" },
                            { label: "Tuesday", value: "Tuesday" },
                            { label: "Wednesday", value: "Wednesday" },
                            { label: "Thursday", value: "Thursday" },
                            { label: "Friday", value: "Friday" },
                            { label: "Saturday", value: "Saturday" },
                            { label: "Sunday", value: "Sunday" },
                        ],
                    } as any,
                    {
                        componentType: ComponentType.RADIO_FIELD,
                        name: "paid_weekly_off",
                        label: "Paid Weekly Off",
                        direction: FlexDirection.ROW,
                        defaultValue: 1,
                        BindValue: "paid_weekly_off",
                        Json_Attribute: "paid_weekly_off",
                        options: [
                            { label: "Yes", value: 1 },
                            { label: "No", value: 0 },
                        ],
                    } as any,
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "notes",
                        label: "Notes",
                        placeholder: "",
                        required: false,
                        maxLength: 150,
                        BindValue: "notes",
                        Json_Attribute: "notes",
                    } as any,
                ],
            },
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    justifyContent: "flex-end",
                    padding: 10,
                },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        name: "Save",
                        onPressAction: "save",
                        style: {
                            backgroundColor: "var(--primary-green)",
                            widthMode: "wrap",
                        },
                    } as any,
                ],
            },
        ],
    },
];
